// Initialize pages lookup dictionary as a function to ensure all dependencies are loaded
const initializePagesLookupDictionary = () => {
  return {
    propertyPage: {
      regex: /^\/properties\/([A-Za-z0-9]+)\/edit$/,
      action: onPropertyPageMatch,
    },
    invoicePage: {
      regex: /^\/invoice\/edit\/[A-Za-z0-9]+$/,
      action: (pathname, regex) => {
        onInvoicePageMatch(pathname, regex);
        onAccountBalanceInvoicePageMatch(pathname, regex);
      },
    },
    onAccountBalancesPageMatchAdvisoryCouncil: {
      regex:
        /^\/dashboard\/account-sheet\/property\/[A-Za-z0-9]+\/account\/[^/]+$/,
      action: onAccountBalancesPageMatch,
    },
    onAccountBalancesPagePropertyMatch: {
      regex: /^\/account-balances\/[A-Za-z0-9]+$/,
      action: onAccountBalancesPagePropertyMatch,
    },
    onAccountBalanceInvoicePageMatchAdvisoryCouncil: {
      regex:
        /^\/dashboard\/account-sheet\/property\/[A-Za-z0-9]+\/account\/[^/]+\/documents\/view/,
      action: onAccountBalanceInvoicePageMatch,
    },
    onAccountBalanceInvoicePageMatchAdministrator: {
      regex: /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+\/invoice\/edit/,
      action: onAccountBalanceInvoicePageMatch,
    },
    onAccountBalancesOverviewPageMatch: {
      regex: /^\/dashboard\/account-sheet\/property\/[^/]+$/,
      action: onAccountBalancesOverviewPageMatch,
    },
    onAccountBalancesPageMatchAdministrator: {
      regex: /^\/account-balances\/[A-Za-z0-9]+\/account\/[^/]+$/,
      action: onAccountBalancesPageMatch,
    },
    paymentsPage: {
      regex: /^\/payments\/invoice\/[A-Za-z0-9]+$/,
      action: onInvoicePageMatch,
    },
    invoiceListPage: {
      regex: /invoice/,
      action: onInvoiceListPageMatch,
    },
    contractsPage: {
      regex: /contract\/all\/edit/,
      action: onContractsPageMatch,
    },
    lettersPage: {
      regex: /letters\/create/,
      action: onLettersPageMatch,
    },
    unitsPage: {
      regex:
        /^\/properties\/[A-Za-z0-9]+\/edit\/unit\/[A-Za-z0-9]+\/contract\/all$/,
      action: onUnitsPageMatch,
    },
    openBalancesPage: {
    regex: /^\/order-open-balances\/listundefined/,
    action: onOpenBalancesPageMatch,
  },
    resolutionTemplatesAgendaPage: {
      regex:
        /^\/owners-meeting\/invitation\/edit\/[A-Za-z0-9]+\/agenda-item\/(?:create|[0-9]+)$/,
      action: onAgendaPageMatch,
    },
    ownersMeetingPage: {
      regex: /^\/owners-meeting\/protocol\/edit\/[0-9]+$/,
      action:
        onOwnersMeetingPageVoting,
    },
    distributionKeysPage: {
      regex: /^\/distribution-keys\/([A-Za-z0-9]+)\//,
      action: onDistributionKeysPageMatch,
    },
    contactPage: {
      regex: /^\/persons\/view-person\/\d+\/edit-person\/\d+$/,
      action: onContactPageMatch,
    }
  }
}

// Backward compatibility: expose as global variable 
// This will be available after all files load
window.pagesLookupDictionary = null

// Initialize when DOM is ready and all functions are available
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.pagesLookupDictionary = initializePagesLookupDictionary()
  })
} else {
  window.pagesLookupDictionary = initializePagesLookupDictionary()
}
